<div class="background">
    <app-header></app-header>
    <app-navbar *ngIf="!isMobile"></app-navbar>
    <section>
        <app-main [isAdmin]="isAdmin" [isStudent]="isStudent"></app-main>
    </section>
</div>